import React, { useState, useEffect } from "react";
import AddForm from "../AddForm";
import { Button, Col, Form } from "react-bootstrap";
import Select from "react-select";
import Markdown from "../Markdown/Markdown";
import { getAllCategoryFilters, getValuesForFilter } from "../../api/getapi";
import { addQuickLink } from "../../api/postapi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AddQuickLinks = () => {
  const [formData, setFormData] = useState({
    slug: "",
    title: "",
    link_text: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
    content: "",
    category_id: "",
    description: "",
    has_filter: false,
    filters: [{ key: "", values: [] }],
    has_faqs: false,
    faqs: [{ question: "", answer: "" }],
  });
  const [validated, setValidated] = useState(false);
  const [availableFilters, setAvailableFilters] = useState([]);
  const [filterValuesCache, setFilterValuesCache] = useState({});
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [loadingFilterValues, setLoadingFilterValues] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigte = useNavigate();

  const categories = [
    { value: 1, label: "Laptops" },
    { value: 2, label: "Mobiles" },
    { value: 3, label: "Tablets" },
    { value: 4, label: "led-monitors" },
    { value: 5, label: "Desktops" },
    { value: 6, label: "Accessories" },
  ];

  // Map plural display names to singular API format
  const getCategoryApiName = (label) => {
    const mapping = {
      Laptops: "laptop",
      Mobiles: "mobile",
      Tablets: "tablet",
      "tv-monitor": "tv-monitor",
      Desktops: "desktop",
      Accessories: "accessories",
    };
    return mapping[label] || label.toLowerCase();
  };

  // Price ranges for each category
  const priceRangesByCategory = {
    1: [
      // Laptop
      { id: 50000, value: "Under 50,000", count: 0 },
      { id: 100000, value: "Under 1,00,000", count: 0 },
      { id: 150000, value: "Under 1,50,000", count: 0 },
      { id: 200000, value: "Under 2,00,000", count: 0 },
      { id: 300000, value: "Under 3,00,000", count: 0 },
    ],
    2: [
      // Mobile
      { id: 20000, value: "Under 20,000", count: 0 },
      { id: 30000, value: "Under 30,000", count: 0 },
      { id: 40000, value: "Under 40,000", count: 0 },
      { id: 50000, value: "Under 50,000", count: 0 },
      { id: 60000, value: "Under 60,000", count: 0 },
      { id: 70000, value: "Under 70,000", count: 0 },
      { id: 80000, value: "Under 80,000", count: 0 },
      { id: 90000, value: "Under 90,000", count: 0 },
      { id: 100000, value: "Under 1,00,000", count: 0 },
    ],
    3: [
      // Tablet
      { id: 30000, value: "Under 30,000", count: 0 },
      { id: 50000, value: "Under 50,000", count: 0 },
      { id: 60000, value: "Under 60,000", count: 0 },
      { id: 70000, value: "Under 70,000", count: 0 },
      { id: 80000, value: "Under 80,000", count: 0 },
      { id: 90000, value: "Under 90,000", count: 0 },
      { id: 100000, value: "Under 1,00,000", count: 0 },
      { id: 150000, value: "Under 1,50,000", count: 0 },
    ],
    4: [
      // tv-monitor
      { id: 30000, value: "Under 30,000", count: 0 },
      { id: 50000, value: "Under 50,000", count: 0 },
      { id: 60000, value: "Under 60,000", count: 0 },
      { id: 70000, value: "Under 70,000", count: 0 },
      { id: 80000, value: "Under 80,000", count: 0 },
      { id: 90000, value: "Under 90,000", count: 0 },
      { id: 100000, value: "Under 1,00,000", count: 0 },
      { id: 200000, value: "Under 2,00,000", count: 0 },
    ],
    5: [
      // Desktop
      { id: 30000, value: "Under 30,000", count: 0 },
      { id: 50000, value: "Under 50,000", count: 0 },
      { id: 60000, value: "Under 60,000", count: 0 },
      { id: 70000, value: "Under 70,000", count: 0 },
      { id: 80000, value: "Under 80,000", count: 0 },
      { id: 90000, value: "Under 90,000", count: 0 },
      { id: 100000, value: "Under 1,00,000", count: 0 },
      { id: 150000, value: "Under 1,50,000", count: 0 },
      { id: 200000, value: "Under 2,00,000", count: 0 },
      { id: 300000, value: "Under 3,00,000", count: 0 },
    ],
    6: [
      // Accessories
      { id: 5000, value: "Under 5,000", count: 0 },
      { id: 10000, value: "Under 10,000", count: 0 },
      { id: 20000, value: "Under 20,000", count: 0 },
      { id: 50000, value: "Under 50,000", count: 0 },
      { id: 100000, value: "Under 1,00,000", count: 0 },
    ],
  };

  const fetchCategoryFilters = async (categoryId) => {
    if (!categoryId || !formData.has_filter) return;
    setIsLoadingFilters(true);
    try {
      const category = categories.find((cat) => cat.value === categoryId);
      if (category) {
        await getAllCategoryFilters(getCategoryApiName(category.label)).then((res) => {
          const dynamicFilters =
            res?.data?.data.map((data) => {
              return {
                value: data?.key,
                label: data?.label,
              };
            }) || [];

          // Add price filter
          const priceFilter = {
            value: "priceTo",
            label: "Price",
          };

          setAvailableFilters([...dynamicFilters, priceFilter]);
        });
      }
    } catch (error) {
      console.error("Error fetching category filters:", error);
      setAvailableFilters([]);
    } finally {
      setIsLoadingFilters(false);
    }
  };

  const fetchCategoryFilterValues = async (categoryId, filterKey, index) => {
    if (!categoryId || !filterKey) {
      return [];
    }

    // Check cache first
    const cacheKey = `${categoryId}_${filterKey}`;
    if (filterValuesCache[cacheKey]) {
      return filterValuesCache[cacheKey];
    }

    setLoadingFilterValues((prev) => ({ ...prev, [index]: true }));
    try {
      let values = [];
      // Handle price filter specially
      if (filterKey === "priceTo") {
        const priceRanges = priceRangesByCategory[categoryId] || [];
        values = priceRanges.map((range) => ({
          value: range.id,
          label: range.value,
        }));
      } else {
        // Handle other filters from API
        const category = categories.find((cat) => cat.value === categoryId);
        if (category) {
          const res = await getValuesForFilter(getCategoryApiName(category.label), filterKey);
          values =
            res?.data?.data.map((data) => ({
              value: data?.id !== undefined ? data?.id : data?.value,
              label: data?.value,
            })) || [];
        }
      }

      // Cache the results
      setFilterValuesCache((prev) => ({ ...prev, [cacheKey]: values }));
      return values;
    } catch (error) {
      console.error("Error fetching filter values:", error);
      return [];
    } finally {
      setLoadingFilterValues((prev) => ({ ...prev, [index]: false }));
    }
  };

  useEffect(() => {
    if (formData.has_filter && formData.category_id) {
      fetchCategoryFilters(formData.category_id);
    }
  }, [formData.category_id, formData.has_filter]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Handle slug input - allow editing after the forward slash
    if (name === "slug") {
      // If there's no category selected, allow free editing
      if (!formData.category_id) {
        setFormData((prev) => ({
          ...prev,
          slug: value,
        }));
        return;
      }

      // If there is a category selected, preserve the category part
      const categorySlug = categories.find((cat) => cat.value === formData.category_id)?.label.toLowerCase() + "/" || "";

      // Only update if the user is modifying the part after the category
      if (value.startsWith(categorySlug)) {
        setFormData((prev) => ({
          ...prev,
          slug: value,
        }));
      }
      return;
    }

    // Handle has_filter toggle
    if (name === "has_filter") {
      const newHasFilter = checked;
      setFormData((prev) => ({
        ...prev,
        has_filter: newHasFilter,
        filters: newHasFilter ? prev.filters : [{ key: "", values: [] }],
      }));
      return;
    }

    // Handle has_faqs toggle
    if (name === "has_faqs") {
      const newHasFaqs = checked;
      setFormData((prev) => ({
        ...prev,
        has_faqs: newHasFaqs,
        faqs: newHasFaqs ? prev.faqs : [{ question: "", answer: "" }],
      }));
      return;
    }

    // For other inputs
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFilterKeyChange = async (index, selectedOption) => {
    const filterKey = selectedOption ? selectedOption.value : "";
    const newFilters = [...formData.filters];
    newFilters[index] = { key: filterKey, values: [] };

    setFormData((prev) => ({
      ...prev,
      filters: newFilters,
    }));

    // Fetch filter values if a key is selected
    if (filterKey && formData.category_id) {
      await fetchCategoryFilterValues(formData.category_id, filterKey, index);
    }
  };

  const handleFilterValuesChange = (index, selectedOptions) => {
    const newFilters = [...formData.filters];
    newFilters[index] = { ...newFilters[index], values: selectedOptions || [] };

    setFormData((prev) => ({
      ...prev,
      filters: newFilters,
    }));
  };

  const addFilterPair = () => {
    if (formData.filters.length >= 5) {
      toast.warning("Maximum 5 filters allowed");
      return;
    }
    setFormData((prev) => ({
      ...prev,
      filters: [...prev.filters, { key: "", values: [] }],
    }));
  };

  const removeFilterPair = (index) => {
    if (formData.filters.length === 1) {
      toast.warning("At least one filter is required when filters are enabled");
      return;
    }
    setFormData((prev) => ({
      ...prev,
      filters: prev.filters.filter((_, i) => i !== index),
    }));
  };

  const handleFaqChange = (index, field, value) => {
    const newFaqs = [...formData.faqs];
    newFaqs[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      faqs: newFaqs,
    }));
  };

  const addFaqPair = () => {
    if (formData.faqs.length >= 5) {
      toast.warning("Maximum 5 FAQs allowed");
      return;
    }
    setFormData((prev) => ({
      ...prev,
      faqs: [...prev.faqs, { question: "", answer: "" }],
    }));
  };

  const removeFaqPair = (index) => {
    if (formData.faqs.length === 1) {
      toast.warning("At least one FAQ is required when FAQs are enabled");
      return;
    }
    setFormData((prev) => ({
      ...prev,
      faqs: prev.faqs.filter((_, i) => i !== index),
    }));
  };

  const handleCategoryChange = (selectedOption) => {
    // Auto-fill slug with the selected category's label in lowercase and add a trailing slash
    if (selectedOption) {
      setFormData((prev) => ({
        ...prev,
        category_id: selectedOption.value,
        slug: `${selectedOption.label.toLowerCase()}/`,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        category_id: "",
        slug: "",
      }));
    }
    const value = selectedOption ? selectedOption.value : "";
    const prevCategoryId = formData.category_id;

    // Update category and reset filter values but keep has_filter state
    setFormData((prev) => ({
      ...prev,
      category_id: value,
      filters: [{ key: "", values: [] }],
    }));

    // Clear cache when category changes
    setFilterValuesCache({});

    // If filters were enabled and category changed, fetch new filters
    if (formData.has_filter && value && value !== prevCategoryId) {
      fetchCategoryFilters(value);
    }
  };

  const handleDescriptionChange = (value, _, __, content) => {
    setFormData((prev) => ({
      ...prev,
      content: value,
      // Store plain text version if needed (optional)
      description: content?.getText ? content.getText() : "",
    }));
  };
  const keyMapping = {
    accessory_type_ids: "accessoryType",
    brand_ids: "brandName",
    battery_type_ids: "batteryType",
    battery_capacity_ids: "batteryCapacity",
    city: "cityName",
    city_id: "cityName",
    condition_ids: "conditionName",
    condition: "conditionName",
    camera_specs_ids: "cameraSpec",
    camera_specs: "cameraSpec",
    desktop_type_ids: "desktopType",
    display_type: "displayType",
    display_type_ids: "displayType",
    fingerprint_ids: "fingerprint",
    generation_ids: "generation",
    graphics_card_name_ids: "graphicsCardName",
    graphics_card_type_ids: "graphicsCardType",
    graphics_card_memory_ids: "graphicsCardMemory",
    is_backlit_keyboard: "isBacklitKeyboard",
    is_e_sim: "isESim",
    is_sim_support: "isSimSupport",
    is_smart_tv: "isSmartTv",
    is_pta_approved: "isPtaApproved",
    is_touch_screen: "isTouchScreen",
    is_tv_certified: "isTVCertified",
    is_webcam: "isWebcam",
    keyboard_ids: "keyboard",
    laptop_type_ids: "laptopType",
    model_ids: "modelName",
    network_band_ids: "networkBand",
    operating_system_ids: "operatingSystem",
    processor_ids: "processor",
    priceFrom: "minPrice",
    priceTo: "maxPrice",
    primary_storage_capacity: "primaryStorageCapacity",
    secondary_storage_capacity: "secondaryStorageCapacity",
    ram_ids: "ramCapacity",
    ram_capacity_ids: "ramCapacity",
    ram_type_ids: "ramType",
    refresh_rate_ids: "refreshRate",
    resolution_ids: "resolution",
    screen_protection_ids: "screenProtection",
    screen_size_ids: "screenSize",
    screen_type_ids: "screenType",
    sim_type_ids: "simType",
    speaker_ids: "speaker",
    storage_mobile_ids: "primaryStorageCapacity",
    storage_ssd_ids: "PrimaryStorageCapacity",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    // Validate form
    if (!formData.category_id) {
      toast.error("Please select a category");
      setValidated(true);
      return;
    }

    if (formData.content.length < 200) {
      toast.error("Content must be at least 200 characters");
      setValidated(true);
      return;
    }

    if (formData.has_filter) {
      for (let i = 0; i < formData.filters.length; i++) {
        if (!formData.filters[i].key) {
          toast.error(`Please select a filter name for filter ${i + 1}`);
          setValidated(true);
          return;
        }

        if (formData.filters[i].values.length === 0) {
          toast.error(`Please select at least one value for filter ${i + 1}`);
          setValidated(true);
          return;
        }
      }
    }

    // Validate FAQs only if FAQ section is enabled
    if (formData.has_faqs) {
      for (let i = 0; i < formData.faqs.length; i++) {
        if (!formData.faqs[i].question.trim()) {
          toast.error(`Please enter a question for FAQ ${i + 1}`);
          setValidated(true);
          return;
        }

        if (!formData.faqs[i].answer.trim()) {
          toast.error(`Please enter an answer for FAQ ${i + 1}`);
          setValidated(true);
          return;
        }
      }
    }

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      toast.error("Please fill in all required fields correctly");
      return;
    }

    setValidated(true);
    setIsSubmitting(true);

    // Prepare data for submission
    const normalizedFilters = formData.has_filter
      ? formData.filters.map((filter) => ({
          filter_name: filter.key ? availableFilters.find((f) => f.value === filter.key)?.label || "" : "",
          filter_key: filter.key,
          filter_values: filter.values.map((v) => v.value),
          key: keyMapping[filter.key],
          value: filter.values.map((v) => v.label),
        }))
      : [];

    const submitData = {
      quickLink: {
        slug: formData.slug,
        title: formData.title,
        link_text: formData.link_text,
        meta_title: formData.meta_title,
        meta_description: formData.meta_description,
        meta_keyword: formData.meta_keywords,
        category_id: formData.category_id,
        category_name: formData.category_id ? categories.find((cat) => cat.value === formData.category_id).label : "",
        content: formData.content,
        is_core: !formData.has_filter,
        is_active: false,
      },
      quickLinkFilter: formData.has_filter
        ? formData.filters.map((filter) => ({
            filter_name: filter.key ? availableFilters.find((f) => f.value === filter.key)?.label || "" : "",
            key: keyMapping[filter.key],
            filter_key: keyMapping[filter.key],
            value: filter.values.map((v) => v.label).join(","),
            filter_values: filter.values.map((v) => v.label).join(","),
          }))
        : [],
      faqs: formData.has_faqs ? formData.faqs.filter((faq) => faq.question.trim() && faq.answer.trim()) : [],
    };

    await addQuickLink(submitData)
      .then((res) => {
        toast.success("Quick link added successfully!");
        navigte("/quickLinks");
      })
      .catch((e) => {
        console.log(e);
        toast.error(e?.response?.data?.error?.message || "Error adding quick link. Please try again.");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
    // Add your form submission logic here
    // Example: await yourAPICall(submitData);
  };

  return (
    <div className="add-quick-links">
      <AddForm>
        <h4 className="fs-12">Add QuickLinks</h4>
        <Form noValidate validated={validated} onSubmit={handleSubmit} className="d-flex flex-column gap-2">
          <Form.Group>
            <Select name="category_id" value={categories.find((cat) => cat.value === formData.category_id) || null} onChange={handleCategoryChange} options={categories} isClearable isSearchable placeholder="Select a category" className="basic-single" classNamePrefix="select" required />
            {validated && !formData.category_id && <div className="invalid-feedback d-block">Please select a category.</div>}
          </Form.Group>

          <Form.Group>
            <Form.Control name="slug" value={formData.slug} onChange={handleInputChange} placeholder="/laptop or /laptop/i5-Generation-Laptops" type="text" required />
            <Form.Control.Feedback type="invalid">Please provide a valid slug (e.g., /laptop or /laptop/i5-laptops).</Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Control name="title" value={formData.title} onChange={handleInputChange} placeholder="Title (e.g., Best Laptops in Pakistan)" type="text" required />
            <Form.Control.Feedback type="invalid">Please provide a title.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Control name="link_text" value={formData.link_text} onChange={handleInputChange} placeholder="Link Text (e.g., View All Laptops)" type="text" required />
            <Form.Control.Feedback type="invalid">Please provide link text.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Control name="meta_title" value={formData.meta_title} onChange={handleInputChange} placeholder="Meta Title" type="text" required />
            <Form.Control.Feedback type="invalid">Please provide a meta title.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Control name="meta_description" value={formData.meta_description} onChange={handleInputChange} placeholder="Meta Description" as="textarea" rows={3} required />
            <Form.Control.Feedback type="invalid">Please provide a meta description.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Control name="meta_keywords" value={formData.meta_keywords} onChange={handleInputChange} placeholder="Meta Keywords (comma separated)" type="text" required />
            <Form.Control.Feedback type="invalid">Please provide meta keywords (comma separated).</Form.Control.Feedback>
          </Form.Group>

          <Form.Group as={Col} lg="12" md="12" sm="12" className="mb-3">
            <Markdown
              value={formData.content}
              setValue={(value) => handleDescriptionChange(value)}
              setText={(text) => {
                // Optional: Store plain text version if needed
                setFormData((prev) => ({
                  ...prev,
                  description: text,
                }));
              }}
              placeholder="Enter Description (5,000 Characters)"
            />
            <Form.Control hidden name="content" value={formData.content} as="textarea" minLength={200} maxLength={5000} required />
            <Form.Control.Feedback type="invalid">
              {formData.content.length === 0 ? "Please enter the description (minimum 200 characters)." : formData.content.length < 200 ? `Content must be at least 200 characters. Current: ${formData.content.length}/200` : "Please enter the description."}
            </Form.Control.Feedback>
            {formData.content.length > 0 && formData.content.length < 200 && <Form.Text className="text-danger">{200 - formData.content.length} more characters required (minimum 200).</Form.Text>}
            {formData.content.length >= 200 && <Form.Text className="text-success">✓ Content length: {formData.content.length} characters</Form.Text>}
          </Form.Group>

          <Form.Group as={Col} lg="12" md="12" sm="12" className="mb-3">
            <div className="d-flex align-items-center gap-2">
              <Form.Check type="switch" id="has_filter" name="has_filter" label="Has Filters" checked={formData.has_filter} onChange={handleInputChange} disabled={!formData.category_id} className={!formData.category_id ? "opacity-50" : ""} />
              {!formData.category_id && <small className="text-muted ms-2">Select a category first</small>}
            </div>
          </Form.Group>

          {formData.has_filter && (
            <>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Form.Label className="mb-0">
                  Filters: <span className="text-danger">*</span>
                </Form.Label>
                <Button variant="success" size="sm" onClick={addFilterPair} disabled={!formData.category_id || isLoadingFilters || formData.filters.length >= 5}>
                  + Add Filter {formData.filters.length >= 5 ? "(Max 5)" : `(${formData.filters.length}/5)`}
                </Button>
              </div>

              {formData.filters.map((filter, index) => {
                const cacheKey = formData.category_id ? `${formData.category_id}_${filter.key}` : null;
                const availableValues = cacheKey ? filterValuesCache[cacheKey] || [] : [];

                return (
                  <div key={index} className="border rounded p-3 mb-3 position-relative">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0">Filter {index + 1}</h6>
                      {formData.filters.length > 1 && (
                        <Button variant="danger" size="sm" onClick={() => removeFilterPair(index)}>
                          Remove
                        </Button>
                      )}
                    </div>

                    <Form.Group className="mb-3">
                      <Form.Label>Filter Name:</Form.Label>
                      <Select
                        value={availableFilters.find((f) => f.value === filter.key) || null}
                        onChange={(selected) => handleFilterKeyChange(index, selected)}
                        options={availableFilters}
                        isClearable
                        isSearchable
                        isLoading={isLoadingFilters}
                        loadingMessage={() => "Loading filters..."}
                        placeholder="Select a filter name"
                        className="basic-single"
                        classNamePrefix="select"
                        isDisabled={!formData.category_id || isLoadingFilters}
                      />
                    </Form.Group>

                    {filter.key && (
                      <Form.Group className="mb-0">
                        <Form.Label>Filter Values:</Form.Label>
                        <Select
                          isMulti
                          value={filter.values}
                          onChange={(selected) => handleFilterValuesChange(index, selected)}
                          options={availableValues}
                          isClearable
                          isSearchable
                          isLoading={loadingFilterValues[index]}
                          loadingMessage={() => "Loading filter values..."}
                          placeholder="Select filter values..."
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isDisabled={!filter.key || loadingFilterValues[index]}
                        />
                        {filter.key && filter.values.length === 0 && validated && <div className="invalid-feedback d-block">Please select at least one filter value</div>}
                      </Form.Group>
                    )}
                  </div>
                );
              })}
            </>
          )}

          {/* FAQ Toggle */}
          <Form.Group as={Col} lg="12" md="12" sm="12" className="mb-3">
            <div className="d-flex align-items-center gap-2">
              <Form.Check type="switch" id="has_faqs" name="has_faqs" label="Has FAQs" checked={formData.has_faqs} onChange={handleInputChange} />
            </div>
          </Form.Group>

          {formData.has_faqs && (
            <>
              <div className="d-flex justify-content-between align-items-center mb-2 mt-4">
                <Form.Label className="mb-0">
                  FAQs: <span className="text-danger">*</span>
                </Form.Label>
                <Button variant="success" size="sm" onClick={addFaqPair} disabled={formData.faqs.length >= 5}>
                  + Add FAQ {formData.faqs.length >= 5 ? "(Max 5)" : `(${formData.faqs.length}/5)`}
                </Button>
              </div>

              {formData.faqs.map((faq, index) => (
                <div key={index} className="border rounded p-3 mb-3 position-relative">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="mb-0">FAQ {index + 1}</h6>
                    {formData.faqs.length > 1 && (
                      <Button variant="danger" size="sm" onClick={() => removeFaqPair(index)}>
                        Remove
                      </Button>
                    )}
                  </div>

                  <Form.Group className="mb-3">
                    <Form.Label>Question:</Form.Label>
                    <Form.Control type="text" placeholder="Enter question..." value={faq.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} required />
                    {validated && !faq.question.trim() && <div className="invalid-feedback d-block">Please enter a question</div>}
                  </Form.Group>

                  <Form.Group className="mb-0">
                    <Form.Label>Answer:</Form.Label>
                    <Form.Control as="textarea" rows={3} placeholder="Enter answer..." value={faq.answer} onChange={(e) => handleFaqChange(index, "answer", e.target.value)} required />
                    {validated && !faq.answer.trim() && <div className="invalid-feedback d-block">Please enter an answer</div>}
                  </Form.Group>
                </div>
              ))}
            </>
          )}

          <Button variant="primary" type="submit" className="mt-3" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Form>
      </AddForm>
    </div>
  );
};

export default AddQuickLinks;
